<template>
  <div class="update-Mcq-adaptive-game-List container-fluid padding-right-0px">
    <div class="">
      <div class="row">
        <div class="col-md-12 col-lg-12 padding-right-0px">
          <ol class="col-md-12 col-lg-12 text-align-left padding-left-0px padding-right-0px">
            <li v-for='currMcqObj in getMcqList' class="padding-3px" :key="currMcqObj.QuestionId">{{currMcqObj.Title}}
              <span class="pull-right">
                <img :src="useredit" alt="useredit" height="14" width="15" class="cursor-pointer padding-bottom-3px" @click="performOperation($event,'edit', currMcqObj)">
                <img :src="deleteIcon" alt="useredit" height="15" width="15" class="cursor-pointer padding-bottom-3px" @click="performOperation($event,'delete', currMcqObj)">
              </span>
            </li>
          </ol>
        </div>
        <li class="list-group-item list-group-item-danger text-align-center" v-if="parseInt(getMcqList.length) === 0">No Mcq(s) found</li>
      </div>
    </div>
    <update-mcq v-if="showEditMcqOverlay" :ElementObj="currSelectedMcqObj" :lessonObj="getParentLessonObj" @closeUpdateMCQOverlay="updateCloseUpdateMcqOverlay"></update-mcq>
    <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
    <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixDeleteMcqString" v-bind:postfixString="postDeleteMcqString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="deleteSelectedElement"></confirmation-alert>
  </div>
</template>

<script>
import Loader from '@/components/dashboard/Loader'
import { constants } from '@/utils/constants'
import AlertBox from '@/components/AlertOverlay'
import { elementService } from '@/server-util/element-service'
import edit from '../../../assets/images/edit.svg'
import deleteIcon from '../../../assets/images/delete.svg'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import UpdateMCQ from '@/components/adaptive_game/Update-element/UpdateAdaptiveGameUpdateMCQElement'
import findIndex from 'lodash/findIndex'
export default {
  props: ['mcqList', 'lessonObj', 'adaptiveGameResp'],
  data: function () {
    return {
      useredit: edit,
      deleteIcon: deleteIcon,
      currSelectedMcqObj: null,
      showAlertDialog: false,
      errorMsg: '',
      showConfirmationBox: false,
      prefixDeleteMcqString: 'Are you sure you want to delete ',
      postDeleteMcqString: '?',
      showEditMcqOverlay: false
    }
  },
  name: 'update-Mcq-adaptive-game-List',
  methods: {
    updateCloseUpdateMcqOverlay (value) {
      this.showEditMcqOverlay = !value.closeOverlay
      var _this = this
      if (value.refreshList) {
        var currSelectedArrIndex = findIndex(this.getMcqList, function (o) {
          return o.ElementId === _this.currSelectedMcqObj.ElementId
        })
        currSelectedArrIndex = parseInt(currSelectedArrIndex)
        this.mcqList[currSelectedArrIndex] = value.updatedObj
        _this.$emit('updateMcqList', this.mcqList)
      }
    },
    performOperation: function (event, selectedOperation, mcqObj) {
      this.currSelectedMcqObj = mcqObj
      switch (selectedOperation) {
        case 'delete':
          this.showConfirmationBox = true
          this.prefixDeleteMcqString = 'Are you sure you want to delete '
          this.postDeleteMcqString = '\'' + this.currSelectedMcqObj.Title + '\'?'
          break
        case 'edit':
          this.showEditMcqOverlay = true
          break
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button of delete element overlay
      this.showConfirmationBox = value
    },
    deleteSelectedElement (value) {
      // AK: Hide Delete Confirmation Box
      this.showConfirmationBox = false
      var _this = this
      var storeObj = this.$store
      if (value) {
        if (
          this.currSelectedMcqObj !== undefined
        ) {
          // this.showSpinner = true
          this.$store.state.isLoading = true
          elementService
            .deleteElement(storeObj.state.access_token, _this.currSelectedMcqObj.ElementId)
            .then(responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                var updatedList = _this.removeCurrentElementFromList()
                _this.$emit('updateMcqList', updatedList)
                _this.$store.state.isLoading = false
              } else {
                this.showAlertDialog = true
                this.errorMsg = 'Oops! Something went wrong. Please try again.'
                // this.showSpinner = false
                this.$store.state.isLoading = false
              }
            }, errorObj => {
              // AK: Hide Spinner
              // this.showSpinner = false
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            })
        } else {
          console.log(
            'Selected currSelectedMcqObj Object is NULL hence declined DELETE OPERATION'
          )
        }
      }
    },
    removeCurrentElementFromList: function () {
      var _this = this
      return this.getMcqList.filter(function (item) {
        return item.ElementId !== _this.currSelectedMcqObj.ElementId
      })
    }
  },
  components: {
    'alert-box': AlertBox,
    'loader': Loader,
    'confirmation-alert': ConfirmationOverlay,
    'update-mcq': UpdateMCQ
  },
  computed: {
    getMcqList: {
      get: function () {
        return this.mcqList
      }
    },
    getParentLessonObj: {
      get: function () {
        return this.lessonObj
      }
    },
    getAdaptiveGameResp: {
      get: function () {
        return this.adaptiveGameResp
      }
    }
  }
}
</script> 
<style scoped>
.animationload {
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10000;
}
.osahanloading {
    animation: 1.5s linear 0s normal none infinite running osahanloading;
    background: #fed37f none repeat scroll 0 0;
    border-radius: 50px;
    height: 50px;
    left: 50%;
    margin-left: -25px;
    margin-top: -25px;
    position: absolute;
    top: 50%;
    width: 50px;
}
.osahanloading::after {
    animation: 1.5s linear 0s normal none infinite running osahanloading_after;
    border-color: #85d6de transparent;
    border-radius: 80px;
    border-style: solid;
    border-width: 10px;
    content: "";
    height: 80px;
    left: -15px;
    position: absolute;
    top: -15px;
    width: 80px;
}
@keyframes osahanloading {
0% {
    transform: rotate(0deg);
}
50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
}
100% {
    transform: rotate(360deg);
}
}
.red{
  background-color: red;
}
.MainDiv
{
  overflow-y: hidden !important;
}
.margin-Top-0Perc{
  margin-top: 0%;
}
.margin-Top-1Perc{
  margin-top: 1%;
}
.margin-Top-2Perc
{
	margin-top: 2%;
}
.margin-Top-3Perc
{
	margin-top: 3%;
}
.margin-Top-8Perc
{
	margin-top: 8%;
}
.margin-bottom-0Perc
{
	margin-bottom: 0%;
}
.margin-bottom-5Perc
{
	margin-bottom: 5%;
}
.margin-bottom-2Perc
{
	margin-bottom: 2%;
}
.margin-top-2Perc
{
	margin-top: 2%;
}
.margin-left-0Perc
{
    margin-left:0%;
}
.margin-left-1Perc
{
    margin-left:2%;
}
.margin-left-2Perc
{
    margin-left:2%;
}
.margin-left-3Perc{
  margin-left:3%;
}
.margin-left-4Perc
{
    margin-left:4%;
}
.margin-left-5Perc{
  margin-left:5%;
}
.margin-left-6Perc{
  margin-left:6%
}
.margin-left-9Perc
{
    margin-left:9%;
}
.padding-Left-30px
{
  padding-left: 3% !important;
}
.text-align-center
{
  text-align: center;
}
.left-border
{
  border-left: 1px solid #aaa;
}

.background-color-red
{
	background-color: red;
}
.cf-border
{
	border:1px solid black;
}
.text-align-left
{
  text-align: left;
}
.font-size-1-3vw
{
  font-size: 1.3vw;
}
.font-size-20px
{
  font-size: 20px;
}
.background-gray{
  background-color: #ddd;

}

.border-rounded{
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}

  .overflow-x-hidden{
    overflow-x: hidden !important;
  }
  .font-size-18px {
  font-size: 18px;
}
.gray-border {
  border: 1px solid #aaa;
}
.white-BG {
  background-color: #ffffff;
}
.width-70Perc {
  width: 70%;
}
.width-90Perc {
  width: 90%;
}
.margin-auto{
margin: auto;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-content {
  position: relative;
  top: 25%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.center-aligned-div {
  margin: 0 auto;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.background-color-white {
  background-color: #ffffff !important;
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.margin-right-1Perc {
  margin-right: 1%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.float-right {
  float: right;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 17px;
}
.padding-right-0px {
  padding-right: 0px !important;
}
switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.text-align-right {
  text-align: right;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color
{
  color: #000 !important;
}
.border-red {
    border:1px solid red;
}
.margin-bottom-2Perc {
    margin-bottom: 2%;
}
.font-size-14px {
    font-size: 14px;
}
.padding-right-6px {
    padding-right:6px; 
}
.padding-top-1Perc {
    padding-top:1%;
}
.padding-left-0px {
    padding-left:0px;
}
.margin-left-10px {
    margin-left: 10px;
}
.padding-3px {
    padding:3px;
}
.padding-bottom-3px {
  padding-bottom:3px;
}
.padding-left-8px {
  padding-left:8px;
}
</style>



// WEBPACK FOOTER //
// src/components/adaptive_game/Update-element/UpdateMcqAdaptiveGameList.vue